import { defineStore } from 'pinia'
import axios from '../config/api.js'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: localStorage.getItem('auth_token') || null,
    isAuthenticated: false
  }),
  
  getters: {
    isLoggedIn: (state) => !!state.token && state.isAuthenticated
  },
  
  actions: {
    async login(credentials) {
      try {
        const response = await axios.post('/api/auth/login', credentials)
        
        this.token = response.data.token
        this.user = response.data.user
        this.isAuthenticated = true
        
        localStorage.setItem('auth_token', this.token)
        
        // Configurer axios pour les futures requêtes
        axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`
        
        return { success: true }
      } catch (error) {
        console.error('Erreur de connexion:', error)
        return { 
          success: false, 
          message: error.response?.data?.error || 'Erreur de connexion' 
        }
      }
    },
    
    async logout() {
      try {
        if (this.token) {
          await axios.post('/api/auth/logout')
        }
      } catch (error) {
        console.error('Erreur lors de la déconnexion:', error)
      } finally {
        this.user = null
        this.token = null
        this.isAuthenticated = false
        
        localStorage.removeItem('auth_token')
        delete axios.defaults.headers.common['Authorization']
      }
    },
    
    async checkAuth() {
      if (!this.token) {
        return false
      }
      
      try {
        axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`
        const response = await axios.get('/api/auth/me')
        
        this.user = response.data.user
        this.isAuthenticated = true
        
        return true
      } catch (error) {
        console.error('Token invalide:', error)
        this.logout()
        return false
      }
    },
    
    initializeAuth() {
      if (this.token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`
        this.checkAuth()
      }
    }
  }
})